import style from './GoBack.module.scss'

interface IProps {
    onGoBack: () => void
}

export const GoBack = (props: IProps) => {
    const { onGoBack } = props
    return (
        <div className={style.container}>
            <span onClick={onGoBack}>Вернуться назад</span>
        </div>
    )
}
